import includes from 'lodash/includes';

/**
 * Filter out locked items from current cart data
 */
export default function(lineItems, currentCartItems) {
    var lockedSeatNos = lineItems
        .filter(item => item.isLocked)
        .map(item => item.seatData.seat_no);

    return currentCartItems.filter(function(item) {
        return !includes(lockedSeatNos, parseInt(item.seat_no, 10));
    });
}



// WEBPACK FOOTER //
// ./src/javascripts/app/lib/cart/excludeLockedItems.js